import Vue from 'vue'
import appConfig from '@/config.js'
import store from '@/store'

const ApiService = {
  getAll(resource, params) {
    console.log('============ API CALL')
    console.log('GET ' + appConfig.api.baseUrl + resource)
    console.log(params)
    console.log('============')
    return Vue.http.get(appConfig.api.baseUrl + resource, params)
  },

  get(resource, id = '', params) {
    console.log('============ API CALL')
    console.log('GET ' + `${appConfig.api.baseUrl}${resource}/${id}`)
    console.log(params)
    console.log('============')
    return Vue.http.get(`${appConfig.api.baseUrl}${resource}/${id}`, params)
  },

  post(resource, params, options) {
    console.log('============ API CALL')
    console.log('POST ' + appConfig.api.baseUrl + resource)
    console.log(params)
    console.log('============')
    return Vue.http.post(`${appConfig.api.baseUrl}${resource}`, params, options)
  },

  update(resource, id, params, options) {
    console.log('============ API CALL')
    console.log('PATCH ' + appConfig.api.baseUrl + resource)
    console.log(params)
    console.log('============')
    return Vue.http.patch(`${appConfig.api.baseUrl}${resource}/${id}`, params, options)
  },

  put(resource, params) {
    console.log('============ API CALL')
    console.log('PUT ' + appConfig.api.baseUrl + resource)
    console.log(params)
    console.log('============')
    return Vue.http.put(`${appConfig.api.baseUrl}${resource}`, params)
  },

  patch(resource, params) {
    console.log('============ API CALL')
    console.log('PATCH ' + appConfig.api.baseUrl + resource)
    console.log(params)
    console.log('============')
    return Vue.http.patch(`${appConfig.api.baseUrl}${resource}`, params)
  },

  delete(resource, params) {
    console.log('============ API CALL')
    console.log('DELETE ' + appConfig.api.baseUrl + resource)
    console.log('============')
    return Vue.http.delete(appConfig.api.baseUrl + resource, params)
  }
}

export default ApiService

export const ConfigService = {
  getEcosystems(params) {
    return ApiService.getAll('ecosystems', params)
  },
  getEcosystem(id, params) {
    return ApiService.get('ecosystems', id, params)
  },
  getCountries(params) {
    return ApiService.getAll('countries', params)
  },
  getRoles(params) {
    return ApiService.getAll('roles', params)
  },
  getVehicleTypes(params) {
    return ApiService.getAll('vehicle-types', params)
  },
  getShippingSizes(params) {
    return ApiService.getAll('sizes', params)
  },
  getShippingTypes(params) {
    return ApiService.getAll('shipping-types', params)
  },
  getShippingSettings(params) {
    return ApiService.getAll('shipping-setting-options', params)
  },
  getPlatforms(params) {
    return ApiService.getAll('platforms', params)
  },
  getReceiverTypes(params) {
    return ApiService.getAll('receiver-types', params)
  },
  getShippingStatusReasons(params) {
    return ApiService.getAll('shipping-status-reasons', params)
  },
  getGeoTypes(params) {
    return ApiService.getAll('geo-types', params)
  }
}

export const ProfileService = {
  get(params) {
    return ApiService.get('users', store.getters.uid, params)
  },
  update(params) {
    return ApiService.update('users', store.getters.uid, params)
  },
  changePassword(params) {
    return ApiService.put(`users/${store.getters.uid}/change-password`, params)
  },
  emailPassword(params) {
    return ApiService.post('password/email', params)
  },
  resetPassword(params) {
    return Vue.http.post(`${appConfig.api.baseUrl}password/reset`, params, { before: (req) => req.headers.set('x-moova-ecosystem-id', params.ecosystem_id || 1) })
  }
}

export const UserService = {
  getAll(params) {
    return ApiService.getAll('companies/users', params)
  },
  get(id, params) {
    return ApiService.get('companies/users', id, params)
  },
  create(params) {
    return ApiService.post('companies/users', params)
  },
  createCourier(params) {
    return ApiService.post(`carriers/${store.getters.profile.company_id}/couriers`, params)
  },
  update(id, params) {
    return ApiService.update('companies/users', id, params)
  },
  enable(id, params) {
    return ApiService.put(`companies/users/${id}/enable`, params)
  },
  disable(id, params) {
    return ApiService.delete(`companies/users/${id}/disable`, params)
  },
  addRole(id, params) {
    return ApiService.post(`companies/users/${id}/roles`, params)
  },
  removeRole(id, params) {
    return ApiService.delete(`companies/users/${id}/roles`, params)
  },
  changePassword(params) {
    return ApiService.put('carriers/users/change-password', params)
  },
  changePhone(params) {
    return ApiService.patch('users/change-phone', params)
  },
  addAddress(id, params) {
    return ApiService.post(`users/${id}/addresses`, params)
  },
  updateAddress(id, fk, params) {
    return ApiService.update(`users/${id}/addresses`, fk, params)
  },
  deleteAddress(id, fk, params) {
    return ApiService.delete(`users/${id}/addresses/${fk}`, params)
  },
  addVehicle(id, params) {
    return ApiService.post(`companies/users/${id}/vehicles`, params)
  },
  updateVehicle(id, fk, params) {
    return ApiService.update(`companies/users/${id}/vehicles`, fk, params)
  },
  deleteVehicle(id, fk, params) {
    return ApiService.delete(`companies/users/${id}/vehicles/${fk}`, params)
  }
}

export const CompanyService = {
  getAll(params) {
    return ApiService.getAll('companies', params)
  },
  get(id, params) {
    return ApiService.get('companies', id, params)
  },
  create(params) {
    return ApiService.post('gcm/companies', params)
  },
  update(id, params) {
    return ApiService.update('gcm/companies', id, params)
  },
  delete(id, params) {
    return ApiService.delete(`gcm/companies/${id}`, params)
  },
  createUser(params) {
    return ApiService.post('companies/users', params)
  },
  addVehicle(id, params) {
    return ApiService.post(`companies/${id}/vehicles`, params)
  },
  updateVehicle(id, fk, params) {
    return ApiService.update(`companies/${id}/vehicles`, fk, params)
  },
  deleteVehicle(id, fk, params) {
    return ApiService.delete(`companies/${id}/vehicles/${fk}`, params)
  }
}

export const TourService = {
  getAll(params) {
    return ApiService.getAll(`carriers/${store.getters.profile.company_id}/tours`, params)
  },
  get(id, params) {
    return ApiService.get(`carriers/${store.getters.profile.company_id}/tours`, id, params)
  },
  assign(id, courierId) {
    return ApiService.post(`carriers/${store.getters.profile.company_id}/tours/${id}/assign`, { courier_id: courierId })
  }
}

export const ShippingService = {
  getAll(params) {
    return ApiService.getAll(`carriers/${store.getters.profile.company_id}/shippings`, params)
  },
  get(id, params) {
    return ApiService.get(`carriers/${store.getters.profile.company_id}/shippings`, id, params)
  },
  create(params) {
    return ApiService.post('shippings', params)
  },
  update(id, params, options) {
    return ApiService.update(`carriers/${store.getters.profile.company_id}/shippings`, id, params, options)
  },
  assign(id, courierId, options) {
    return ApiService.post(`carriers/${store.getters.profile.company_id}/shippings/${id}/assign`, { courier_id: courierId }, options)
  },
  attachFile(id, payload) {
    const formData = new FormData()
    formData.append('file', payload.file, payload.file.name)
    return ApiService.post('files', formData)
      .then(response => {
        payload.full_path = response.body.full_path
        if (!payload.comment) {
          delete payload.comment
        }
        if (!payload.type) {
          delete payload.type
        }
        return ApiService.post(`shippings/${id}/photos`, payload)
      })
  },
  deleteAttachment(id, attachmentId) {
    return ApiService.delete(`shippings/${id}/photos/${attachmentId}`)
  }
}

export const PlatformInformationService = {
  // Generic core-api endpoint (v1): fails for shipments of companies migrated to meli-v2
  get(id, options) {
    return ApiService.get('shippings', `${id}/platform-information`, options)
  },
  // meli-v2 lookup resolved by core-api (404 when the shipment is not meli-v2 or the seller has
  // no application, 502 when moova-integrations fails): no credentials in the front
  getV2(id, options) {
    return ApiService.get('shippings', `${id}/platform-information/v2`, options)
  }
}

export const OcrPrecheckService = {
  // External OCR service (absolute URL): the auth interceptor strips the Moova
  // Authorization header for non-API URLs, and skipErrorAlert keeps the global
  // error alert quiet — precheck failures must never block or bother the upload.
  lightUpload(url, key, file) {
    const formData = new FormData()
    formData.append('file', file, file.name)
    formData.append('key', key)
    return Vue.http.post(url, formData, { timeout: 30000, skipErrorAlert: true })
  }
}

export const ShippingOrderService = {
  getAll(params) {
    return ApiService.getAll('shipping-orders', params)
  },
  get(id, params) {
    return ApiService.get('shipping-orders', id, params)
  },
  create(params) {
    return ApiService.post('shipping-orders', params)
  },
  update(id, params) {
    return ApiService.update('shipping-orders', id, params)
  }
}

export const ItemService = {
  getAll(params, gcm = false) {
    if (!gcm) {
      return ApiService.getAll('items', params)
    } else {
      return ApiService.getAll('gcm/items', params)
    }
  },
  async getAllPages(params, gcm = false) {
    let allData = []
    let page = 0
    let lastPage = 0
    let finalResponse = null

    do {
      const currentParams = { ...params, params: { ...(params?.params || {}), page } }
      const response = await this.getAll(currentParams, gcm)

      finalResponse = finalResponse || response
      if (response?.body?.data) {
        allData = allData.concat(response.body.data)
      }

      const body = response?.body || {}
      const pageInfo = body.pagination || body.meta || body
      lastPage = pageInfo.limit ? Math.ceil(pageInfo.total / pageInfo.limit) - 1 : 0

      page++
    } while (page <= lastPage)

    if (finalResponse?.body) {
      finalResponse.body.data = allData
    }
    return finalResponse
  },
  getShippingHistory(params) {
    return ShippingService.getAll(params)
  },
  addToShipping(itemId, shippingId) {
    return ApiService.post(`shippings/${shippingId}/items/${itemId}`) // 'items', id, { shipping_id: shippingId })
  },
  removeFromShipping(itemId, shippingId) {
    return ApiService.delete(`shippings/${shippingId}/items/${itemId}`)
  },
  enable(id, params) {
    return ApiService.update('items', id, { active: true })
  },
  disable(id, params) {
    return ApiService.update('items', id, { active: false })
  },
  getTrackingHistory(params) {
    return ApiService.getAll('items-tracking/history', params)
  },
  getTrackingHistoryEvents(params) {
    return ApiService.getAll('items-tracking/history/events', params)
  }
}

export const TrackingService = {
  getAll(params) {
    return ApiService.getAll('tracking-history', params)
  }
}

export const GeofenceService = {
  getAll(params) {
    return ApiService.getAll('geo-fences', params)
  },
  get(id, params) {
    return ApiService.get('geo-fences', id, params)
  },
  create(params) {
    return ApiService.post('geo-fences', params)
  },
  update(id, params) {
    return ApiService.update('geo-fences', id, params)
  },
  delete(id, params) {
    return ApiService.delete(`geo-fences/${id}`, params)
  },
  fetchExternalData(params) {
    return ApiService.getAll('platforms/g3/locations', params)
  },
  addGeofence(parentId, childId) {
    const params = {
      geo_fence_id_parent: parentId,
      geo_fence_id_child: childId
    }
    return ApiService.post('geo-fence-geo-fences', params)
  },
  removeGeofence(parentId, childId) {
    return ApiService.delete(`geo-fences/${parentId}/geo-fence/${childId}`)
  },
  addGeoline(fenceId, lineId) {
    const params = {
      geo_fence_id: fenceId,
      geo_line_id: lineId
    }
    return ApiService.post('geo-fence-geo-lines', params)
  },
  removeGeoline(fenceId, lineId) {
    return ApiService.delete(`geo-fences/${fenceId}/geo-line/${lineId}`)
  },
  addGeopoint(fenceId, pointId) {
    const params = {
      geo_fence_id: fenceId,
      geo_point_id: pointId
    }
    return ApiService.post('geo-fence-geo-points', params)
  },
  removeGeopoint(fenceId, pointId) {
    return ApiService.delete(`geo-fences/${fenceId}/geo-point/${pointId}`)
  },
  getItems(fenceId, params) {
    return ApiService.getAll(`geo-fences/${fenceId}/items`, params)
  }
}

export const GeoLineService = {
  getAll(params) {
    return ApiService.getAll('geo-lines', params)
  },
  get(id, params) {
    return ApiService.get('geo-lines', id, params)
  },
  create(params) {
    return ApiService.post('geo-lines', params)
  },
  update(id, params) {
    return ApiService.update('geo-lines', id, params)
  },
  delete(id, params) {
    return ApiService.delete(`geo-lines/${id}`, params)
  }
}

export const GeoPointService = {
  getAll(params) {
    return ApiService.getAll('geo-points', params)
  },
  get(id, params) {
    return ApiService.get('geo-points', id, params)
  },
  create(params) {
    return ApiService.post('geo-points', params)
  },
  update(id, params) {
    return ApiService.update('geo-points', id, params)
  },
  delete(id, params) {
    return ApiService.delete(`geo-points/${id}`, params)
  }
}

export const GeoTypeService = {
  getAll(params) {
    return ApiService.getAll('geo-types', params)
  },
  get(id, params) {
    return ApiService.get('geo-types', id, params)
  },
  create(params) {
    return ApiService.post('geo-types', params)
  },
  update(id, params) {
    return ApiService.update('geo-types', id, params)
  }
}
